module.exports = __webpack_public_path__ + "img/northeast-fall-992x550.2497cb65.jpg";